// src/Blog/components/BlogHeader.js
import React from "react";

function BlogHeader() {
  return (
    <div style={{ width: '100%', textAlign: 'left', marginBottom: '40px' }}>
      <h1>Blog & Notes</h1>
      
      <h3>Why make a blog?</h3>
      <ul style={{ lineHeight: 1.7, paddingLeft: '1.2rem' }}>
        <li>
          Track my growth: A living archive of my technical journey.
        </li>
        <li>
          Clarify my thinking: Writing turns vague ideas into concrete logic.
        </li>
      </ul>
    </div>
  );
}

export default BlogHeader;